export const MINIMUM_HANDLE_INDEX = 0;
export const MAXIMUM_HANDLE_INDEX = 1;
